var classes = {
  "accordionHeader": "accordionHeader__Gv-DQ",
  "accordionButton": "accordionButton__EIW4V",
  "accordionButtonText": "accordionButtonText__lcW6F",
  "accordionHeading": "accordionHeading__fU3Fb",
  "srOnly": "srOnly__gj9V3"
};
export { classes as default };